import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

const CustomInputHorizontal = (props) => {
    const {
        title,
        required,
        inputType,
        handleInputChange = () => {},
        name,
        id,
        isError,
        isSuccess,
        message,
        minValue,
        maxValue,
        readOnly,
        value,
        placeholder,
        disabled,
        autoFocus,
        className,
        labelEnable = true,
        maxCarryLength
    } = props;

    return (
        <div
            className={`pt-[10px] grid gap-y-2 md:gap-y-0 ${
                labelEnable ? "grid-cols-1 md:grid-cols-12" : "grid-cols-1"
            }`}
        >
            {/* LABEL */}
            {labelEnable && (
                <div className="col-span-1 md:col-span-4 flex items-start md:items-center">
                    <label className="block text-sm text-[#000000DE]">
                        {title}
                        {required && (
                            <span className="text-[#EF4444] ml-1">*</span>
                        )}
                    </label>
                </div>
            )}

            {/* INPUT */}
            <div
                className={`relative ${
                    labelEnable ? "col-span-1 md:col-span-8" : "col-span-12"
                }`}
            >
                <input
                    autoFocus={autoFocus}
                    type={inputType}
                    name={name}
                    id={id}
                    className={`h-10 w-full placeholder-400 form-control focus:!border-[#E5E7EB] focus:!outline-none focus:!shadow-none focus-visible:!outline-none active:!outline-none ${className}
                        ${isError && message ? "invalid" : ""}
                        ${isSuccess ? "success" : ""}
                        ${(isError && message) || isSuccess ? "pr-12" : ""}
                    `}
                    {...(inputType === "number"
                        ? { min: minValue, max: maxValue }
                        : {})}
                    readOnly={readOnly}
                    disabled={disabled}
                    onChange={handleInputChange}
                    value={value}
                    placeholder={placeholder}
                    maxLength={maxCarryLength}
                />

                {/* SUCCESS ICON */}
                {isSuccess && (
                    <span className="absolute inset-y-0 right-0 px-3 py-3">
                        <DoneIcon
                            fontSize="small"
                            className="text-green-500"
                        />
                    </span>
                )}

                {/* ERROR ICON */}
                {isError && message && (
                    <span className="absolute inset-y-0 right-0 px-3 py-3">
                        <ErrorIcon
                            fontSize="small"
                            className="text-red-500"
                        />
                    </span>
                )}
            </div>

            {/* ERROR MESSAGE */}
            {labelEnable && isError && (
                <div className="col-span-1 md:col-start-5 md:col-span-8">
                    <p className="text-[14px] text-red-500 mt-1">
                        {message}
                    </p>
                </div>
            )}
        </div>
    );
};

export default CustomInputHorizontal;